import { DotFoliosPage } from './pages/DotFoliosPage';
import { SapDeliveriesPage } from './pages/SapDeliveriesPage';
import { OutboundSubscriptionsGuidePage } from './pages/OutboundSubscriptionsGuidePage';
import { OutboundSubscriptionsPage } from './pages/OutboundSubscriptionsPage';
/**
 * Rutas de la UI de monitoreo.
 *
 * Todo cuelga de `RequireAuth`, que ademas monta el marco (`AppShell`): sin
 * sesion no se renderiza ninguna pantalla. Las rutas estan en espanol porque son
 * parte de la interfaz — los identificadores del codigo siguen en ingles.
 *
 * El `Router` no vive aca a proposito: la app usa `BrowserRouter` (main.tsx) y
 * los tests `MemoryRouter`, montando este mismo arbol de rutas.
 */
import type { ReactElement } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { RequireAuth } from './components/RequireAuth';
import { DashboardPage } from './pages/DashboardPage';
import { DeadLettersPage } from './pages/DeadLettersPage';
import { FlowGraphPage } from './pages/FlowGraphPage';
import { LoginPage } from './pages/LoginPage';
import { MessageDetailPage } from './pages/MessageDetailPage';
import { MessagesPage } from './pages/MessagesPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { PickingSimulationPage } from './pages/PickingSimulationPage';
import { ProcessesPage } from './pages/ProcessesPage';
import { RunsPage } from './pages/RunsPage';
import { QuarantinePage } from './pages/QuarantinePage';
import { TracePage } from './pages/TracePage';
import { WarehousesPage } from './pages/WarehousesPage';

export function App(): ReactElement {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<RequireAuth />}>
        <Route index element={<Navigate to="/tablero" replace />} />
        <Route path="/tablero" element={<DashboardPage />} />
        <Route path="/mensajes" element={<MessagesPage />} />
        <Route path="/mensajes/:id" element={<MessageDetailPage />} />
        <Route path="/traza/:correlationId" element={<TracePage />} />
        <Route path="/flujo/:correlationId" element={<FlowGraphPage />} />
        <Route path="/corridas" element={<RunsPage />} />
        <Route path="/dead-letters" element={<DeadLettersPage />} />
        <Route path="/referencia/webhooks-salientes" element={<OutboundSubscriptionsGuidePage />} />
        <Route path="/procesos" element={<ProcessesPage />} />
        <Route path="/cuarentena" element={<QuarantinePage />} />
        <Route path="/webhooks-salientes" element={<OutboundSubscriptionsPage />} />
        <Route path="/facturador" element={<DotFoliosPage />} />
        <Route path="/entregas-sap" element={<SapDeliveriesPage />} />
        <Route path="/bodegas" element={<WarehousesPage />} />
        <Route path="/simulacion/picking" element={<PickingSimulationPage />} />

        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
